import * as getters from '@/store/modules/transfers/internationalCorporate/getters'
import * as mutations from '@/store/modules/transfers/internationalCorporate/mutations'
import * as actions from '@/store/modules/transfers/internationalCorporate/actions'

const state = {
    accountsBalances: [],
    customerLimits: [],
    customerPlafonds: [],
    transfersReasons: [],
    operationTypesList: [],
    categoriesList: [],
    paymentTypesList: [],
    transfersExpenses: [],
    currenciesList: [],
    profileUnmaskedInfo: [],
    countriesList: [],
    transfersRequestsList: [],
	transfersRequestsListHasMore: false,
    favoritesList: [],
    internationalCorporateTypes: [],
    internationalBanks: [],
    favoritesHasMore: false
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
